import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import {
    Form,
    Button,
    Input,
    Select
} from 'antd';

const css = require('./index.scss');
const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const getFieldDecorator = this.props.form.getFieldDecorator;
        const editView = this.modulesState.editView;
        const departmentQuery = this.modulesState.departmentQuery ? this.modulesState.departmentQuery : [];
        if (this.modulesState.refreshEdit) {
            this.props.form.resetFields();
            ModulesAction.updateRefreshEdit(false);
        }
        return (
            <div className={css['edit']}>
                <header className={css['edit-header']}>
                    {
                        editView ? (
                            <h2>查看 / 编辑部门</h2>
                        ) : (
                            <h2>新增部门</h2>
                        )
                    }
                </header>
                <div className={css['edit-body']}>
                    <Form key={editView.toString()} className={css['edit-body-form']}>
                        <FormItem label="部门编号">
                            {
                                editView ? (
                                    getFieldDecorator('number', {
                                        rules: [
                                            {
                                                required: true, message: '请输入部门编号'
                                            }
                                        ],
                                        initialValue: this.modulesState.departmentInfo && this.modulesState.departmentInfo.number
                                    })
                                    (<Input key='1'/>)
                                ) : (
                                    getFieldDecorator('number', {
                                        rules: [
                                            {
                                                required: true, message: '请输入部门编号'
                                            }
                                        ],
                                        initialValue: undefined
                                    })
                                    (<Input key='2'/>)
                                )
                            }
                        </FormItem>
                        <FormItem label="部门名称">
                            {
                                editView ? (
                                    getFieldDecorator('name', {
                                        rules: [
                                            {
                                                required: true, message: '请输入部门名称'
                                            }
                                        ],
                                        initialValue: this.modulesState.departmentInfo && this.modulesState.departmentInfo.name
                                    })
                                    (<Input/>)
                                ) : (
                                    getFieldDecorator('name', {
                                        rules: [
                                            {
                                                required: true, message: '请输入部门名称'
                                            }
                                        ],
                                        initialValue: undefined
                                    })
                                    (<Input/>)
                                )
                            }
                        </FormItem>
                        <FormItem label="上级部门">
                            {
                                editView ? (
                                    getFieldDecorator('parentDepartmentId', {
                                        initialValue: this.modulesState.departmentInfo && this.modulesState.departmentInfo.parentDepartmentId
                                    })
                                    (
                                        <Select>
                                            {this.modulesState.parentAvailables.map(department => <Option key={department.departmentId}>{department.name}</Option>)}
                                        </Select>
                                    )
                                ) : (
                                    getFieldDecorator('parentDepartmentId', {
                                        initialValue: this.modulesState.parentId ? this.modulesState.parentId : undefined
                                    })
                                    (
                                        <Select>
                                            {departmentQuery.map(department => <Option key={department.departmentId}>{department.name}</Option>)}
                                        </Select>
                                    )
                                )
                            }
                        </FormItem>
                        <FormItem label="备注">
                            {
                                editView ? (
                                    getFieldDecorator('description', {
                                        initialValue: this.modulesState.departmentInfo && this.modulesState.departmentInfo.description
                                    })
                                    (
                                        <TextArea
                                            onChange={this.wordLengthChange}
                                            rows={8}
                                        />
                                    )
                                ) : (
                                    getFieldDecorator('description', {
                                        initialValue: undefined,
                                        rules: [
                                            {
                                                max: 200, message: '备注长度不能超过200个'
                                            }
                                        ]
                                    })
                                    (
                                    <div>
                                        <TextArea
                                            onChange={this.wordLengthChange}
                                            rows={8}
                                        />
                                        <span>共{this.modulesState.noteWord.length}/200</span>
                                    </div>
                                    )
                                )
                            }
                            {
                                editView && <span>共{this.modulesState.noteWord.length}/200</span>
                            }
                        </FormItem>
                    </Form>
                </div>
                <footer className={css['edit-footer']}>
                    <Button
                        onClick={this.cancel}
                    >取消
                    </Button>
                    <Button
                        onClick={this.saveInfo}
                        type="primary"
                    >保存
                    </Button>
                </footer>
            </div>
        );
    }

    private cancel = () => {
        const editView = this.modulesState.editView;
        if (editView) {
            const description = this.modulesState.departmentInfo.description;
            ModulesAction.updateNoteWord(description);
        } else {
            ModulesAction.updateNoteWord('');
        }
        ModulesAction.updateView(true);
    }

    private saveInfo = () => {
        const state = this.modulesState.editView;
        this.props.form.validateFields((err, vals) => {
            if(!err) {
                if(state) {
                    const departmentOld = this.modulesState.departmentInfo;
                    ModulesAction.updateDepartment(Object.assign({}, departmentOld, vals));
                } else {
                    ModulesAction.createDepartment(vals);
                }
            }
        });
    }

    private wordLengthChange = (e): void => {
        ModulesAction.updateNoteWord(e.target.value);
    }

    private filterDepartmentQuery = () => {
        const query = this.modulesState.departmentQuery;
        const info = this.modulesState.departmentInfo;
        if (query && info) {
            return query.filter(el => {
                return !(el.departmentId === info.departmentId || el.parentDepartmentId === info.departmentId);
            });
        } else {
            return [];
        }
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Organization/UI.Edit.tsx